<template>
  <v-dialog v-model="dialog" max-width="40%">
    <template v-slot:activator="{ on }">
      <v-btn icon small v-on="on">
        <v-icon small>delete</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Delete Batch Composition</v-card-title>
      <v-card-text>
        Are you sure want to do this? This cannot be undone.
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="orange darken-2" dark @click="close">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
        <v-btn color="danger" dark @click="del">
          <v-icon left>check</v-icon>
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BatchRawOrigin from "../../models/BatchRawOrigin";
export default {
  name: "BatchRawOriginDelete",
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    del() {
      BatchRawOrigin
        .$delete(this.id)
        .then(() => this.close());
    }
  }
};
</script>
